import React from 'react';
import PropTypes from 'prop-types';
import RsvpSuccessHeader from './RsvpSuccessHeader';
import EventDetails from './EventDetails';
import EventRsvp from './EventRsvp';


function RsvpSuccess({ guests, events, success, mealOptionsById, wedding, selector, forPreview, onEditRsvp, pristine, valid, submitting }) {
  return (
    <div>
      <RsvpSuccessHeader pristine={pristine} valid={valid} submitting={submitting} />
      <div>
        {events && events.map((event, eventIndex) => (
          <div key={event.id} className="events-container">
            <div className="entity-section rsvp-section rsvp-section-success">
              <EventDetails event={event} success={success} />
              <EventRsvp
                event={event}
                guests={guests}
                wedding={wedding}
                mealOptionsById={mealOptionsById}
                success={success}
                selector={selector}
                forPreview={forPreview}
                eventIndex={eventIndex}
              />
            </div>
          </div>
        ))}
        <div className="btn btn-primary btn-wide edit-rsvp-button" onClick={onEditRsvp}>Edit RSVP</div>
      </div>
    </div>
  );
}

RsvpSuccess.propTypes = {
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
  }),
  guests: PropTypes.arrayOf(PropTypes.shape({})),
  events: PropTypes.arrayOf(PropTypes.shape({})),
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  forPreview: PropTypes.bool,
  mealOptionsById: PropTypes.shape({}),
  selector: PropTypes.func.isRequired,
  success: PropTypes.bool,
  onEditRsvp: PropTypes.func,
};

export default RsvpSuccess;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/RsvpSuccess.jsx